import { AppContext, Step } from "../AppDataProvider/AppDataProvider";
import React, { useContext, useEffect } from "react";
import AvailabilityStep from "./Availability/AvailabilityStep";
import BookingCreated from "./BookingCreated/BookingCreatedStep";
import BookingQuestionsStep from "./BookingQuestions/BookingQuestionsStep";
import DetailsStep from "./Details/DetailsStep";
import { LocationAvailabilityStep } from "./LocationAvailability/LocationAvailabilityStep";
import { MultiTierStep } from "./MultiTier/MultiTierStep";
import OrganisationsStep from "./Organisations/OrganisationsStep";
import PaymentsStep from "./Payments/PaymentsStep";
import { PricePointsStep } from "./PricePoints/PricePointsStep";
import RecurringBookingStep from "./RecurringBooking/RecurringBookingStep";
import { ReservationExpiryTimer } from "../common/components";
import ResourcesStep from "./Resources/ResourcesStep";
import ServicesStep from "./Services/ServicesStep";
import { media } from "../common/styles";
import styled from "styled-components";
const stepMap: Record<Step, React.ReactElement> = {
  availability: <AvailabilityStep />,
  bookingCreated: <BookingCreated />,
  bookingQuestions: <BookingQuestionsStep />,
  details: <DetailsStep />,
  locationAvailability: <LocationAvailabilityStep />,
  multiTier: <MultiTierStep />,
  organisations: <OrganisationsStep />,
  payments: <PaymentsStep />,
  pricePoints: <PricePointsStep />,
  recurringBooking: <RecurringBookingStep />,
  resources: <ResourcesStep />,
  services: <ServicesStep />
};
export function Steps(props: {
  scrollToTop: () => void;
}) {
  const {
    scrollToTop
  } = props;
  const {
    appData
  } = useContext(AppContext);
  const {
    currentStep,
    bookingData,
    showReservationExpiry
  } = appData;
  const {
    confirmedBookingIds,
    reservedSpaceId
  } = bookingData;
  const showReservationExpiryTimer = reservedSpaceId && !showReservationExpiry && !confirmedBookingIds;
  useEffect(() => {
    scrollToTop();
  }, [currentStep, scrollToTop]);
  return <Container data-sentry-element="Container" data-sentry-component="Steps" data-sentry-source-file="Steps.tsx">
      {showReservationExpiryTimer && <ReservationExpiryTimer />}

      {stepMap[currentStep]}
    </Container>;
}
const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  @media ${media.desktop} {
    min-height: 550px;
  }
`;
export default Steps;